import React, { FC, useMemo, useState } from 'react';

import cn from 'classnames';
import Image from 'next/legacy/image';

import WapperIcon from '@components/Icon';
import { I18n } from '@utils/index';

import { AirdropDetailType, ItemProps } from '../detail';
import { Item } from '../item';

import styles from './index.module.less';

export const List: FC<AirdropDetailType> = (props) => {
  const { receiveList, receiveNum, num } = props;
  const [pageNo, setPageNo] = useState<number>(1);
  const [maxPageNo, setMaxPageNo] = useState<number>();
  const [list, setList] = useState<ItemProps[]>();
  const toPrevPage = () => {
    if (pageNo > 1) {
      setPageNo(pageNo - 1);
      setList(getList[pageNo - 2]);
    }
  }
  const toNextPage = () => {
    if (pageNo < maxPageNo) {
      setPageNo(pageNo + 1);
      setList(getList[pageNo])
    }
  };
  const getList = useMemo(() => {
    const newArr = [];
    for (let i = 0; i < receiveList?.length;) {
      newArr.push(receiveList.slice(i, i += 10));
    }
    setMaxPageNo(Math.ceil(receiveList?.length / 10));
    setList(newArr[0]);
    return newArr;
  }, [receiveList]);
  return (
    <div className={styles.wrapper}>
      <div className={styles.brief}>
        <span className={styles.title}>{I18n.t('coyAgfw6')}</span>
        <span className={styles.num}>{receiveNum}/{num}</span>
      </div>
      <div className={styles.container}>
        <div className={styles.header}>
          <span>{I18n.t('7vhZ0iRf')}</span>
          <span>{I18n.t('y0BU37m3')}</span>
          <span>{I18n.t('Wge7jQVy')}</span>
        </div>
        <div className={styles.body}>
          {list?.length > 0 ? list?.map(item => {
            return <Item
              {...item}
              key={item.id}
              />
          }) : <div className={styles.img}>
              <Image src={require('@images/airdrop/historyEmpty.webp')} width={210} height={220} alt={'kikitrade'}/>
              <p className={styles.tip}>{I18n.t('M4qCgErY')}</p>
            </div>}
        </div>
        {!!(receiveNum > 10) && <div className={styles.pagination}>
          <span onClick={toPrevPage}
            className={cn({
              [styles.disabled]: pageNo === 1
            })}
          ><WapperIcon name="arrow-line" className={styles.left}/></span>
          <span className={styles.pageNo}>{pageNo}</span>
          <span onClick={toNextPage}
          className={cn({
            [styles.disabled]: pageNo === maxPageNo
          })}
          ><WapperIcon name="arrow-line" className={styles.right}/> </span>
        </div>}
      </div>
    </div>
  );
};
